import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const ZoomIn = ({
  size,
  type,
  theme,
  className,
  dataTestId = "zoom-in-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M7.38662 4.32578C7.75481 4.32578 8.05328 4.62426 8.05328 4.99245V6.60443H9.66396C10.0322 6.60443 10.3306 6.90291 10.3306 7.2711C10.3306 7.63929 10.0321 7.93776 9.66396 7.93776H8.05328V9.54851C8.05328 9.9167 7.75481 10.2152 7.38662 10.2152C7.01843 10.2152 6.71995 9.9167 6.71995 9.54851V7.93776H5.1079C4.73971 7.93776 4.44124 7.63928 4.44124 7.2711C4.44124 6.90291 4.73971 6.60443 5.1079 6.60443H6.71995V4.99245C6.71995 4.62426 7.01843 4.32578 7.38662 4.32578Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.2911 0.290627C3.49871 0.290627 0.424377 3.36496 0.424377 7.15735C0.424377 10.9497 3.49871 14.0241 7.2911 14.0241C8.87834 14.0241 10.3398 13.4855 11.5027 12.5812L14.4362 15.5147C14.6965 15.775 15.1187 15.775 15.379 15.5147C15.6394 15.2543 15.6394 14.8322 15.379 14.5719L12.4717 11.6645C13.5219 10.4585 14.1578 8.88217 14.1578 7.15735C14.1578 3.36496 11.0835 0.290627 7.2911 0.290627ZM1.75771 7.15735C1.75771 4.10134 4.23509 1.62396 7.2911 1.62396C10.3471 1.62396 12.8245 4.10134 12.8245 7.15735C12.8245 10.2134 10.3471 12.6907 7.2911 12.6907C4.23509 12.6907 1.75771 10.2134 1.75771 7.15735Z"
    />
  </SVGIcon>
);
